import ScChat from './ScChat.vue'
import i18n from './i18n'

const i18nFallback = {
  beforeCreate() {
    // fallback if vue-i18n was not provided
    if (!this.$t || !this._i18n) {
      this.$t = (c) => c
      if (this.$options._componentTag === 'sc-chat') {
        // eslint-disable-next-line
        console.warn('ScChat: vue-i18n was not provided, all the strings will not be translated! and will be displayed as they are!')
      }
    }
  }
}
const setMixin = function (index) {
  for (let key in index.components) {
    setMixin(index.components[key])
  }
  index.mixins = [i18nFallback]
}
setMixin(ScChat)

export { i18n }


export const Plugin = {
  install(Vue, options = {}) {
    /**
     * Makes sure that plugin can be installed only once
     */
    if (this.installed) {
      return
    }

    this.installed = true
    this.componentName = options.componentName || 'hexachat'
    options.locales && mergeI18n(options.locales)
    /**
     * Sets custom component name (if provided)
     */
    Vue.component(this.componentName, ScChat)
  }
}


export const mergeI18n = function (messages) {
  for (let key in messages) {
    if (!i18n.messages[key]) {
      i18n.messages[key] = {}
    }
    Object.assign(i18n.messages[key], messages[key])
  }
}

export default ScChat
